import { render, staticRenderFns } from "./ReactionIcon.vue?vue&type=template&id=a213b910"
import script from "./ReactionIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactionIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a213b910')) {
      api.createRecord('a213b910', component.options)
    } else {
      api.reload('a213b910', component.options)
    }
    module.hot.accept("./ReactionIcon.vue?vue&type=template&id=a213b910", function () {
      api.rerender('a213b910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/ReactionIcon.vue"
export default component.exports